// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3e5dad2d","239":"1392930c","453":"bc091f50","455":"7bc2f78f"}[chunkId] + ".chunk.js";
};